export type VirtualTour = {
  address: string;
  tourUrl: string;
};

export const virtualTours: VirtualTour[] = [
  {
    address: "10 Harbour Isle Dr E #302",
    tourUrl: "https://www.flexmls.com/share/Ecq0v/10-E-Harbour-Isle-Dr-Drive-E-302,-Fort-Pierce,-FL-34949",
  },
  {
    address: "27 Harbour Isle Dr W #305",
    tourUrl: "https://www.flexmls.com/share/Ecq03/27-Harbour-Isle-Drive-W-305,-Fort-Pierce,-FL-34949",
  },
  {
    address: "31 Harbour Isle Dr W PH 5",
    tourUrl: "https://www.flexmls.com/share/EcpyJ/31-HARBOUR-ISLE-Drive-W-PH05,-Fort-Pierce,-FL-34949",
  },
];
